const Claims = () => {
  return (
    <section className="shipping mb-24" id="shipping">
      <div className="container container-lg">
        <div className="row gy-4">
          <div
            className="col-xxl-3 col-sm-6 aos-init aos-animate"
            data-aos="zoom-in"
            data-aos-duration="400"
          >
            <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
              <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                <i className="ph-fill ph-car-profile" />
              </span>
              <div className="">
                <h6 className="mb-0">Free Shipping</h6>
                <span className="text-sm text-heading">
                  Fast and reliable delivery on all orders.
                </span>
              </div>
            </div>
          </div>
          <div
            className="col-xxl-3 col-sm-6 aos-init aos-animate"
            data-aos="zoom-in"
            data-aos-duration="600"
          >
            <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
              <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                <i className="ph-fill ph-hand-heart" />
              </span>
              <div className="">
                <h6 className="mb-0">100% Satisfaction</h6>
                <span className="text-sm text-heading">
                  Hassle-free returns and guaranteed customer satisfaction.
                </span>
              </div>
            </div>
          </div>
          <div
            className="col-xxl-3 col-sm-6 aos-init aos-animate"
            data-aos="zoom-in"
            data-aos-duration="800"
          >
            <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
              <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                <i className="ph-fill ph-credit-card" />
              </span>
              <div className="">
                <h6 className="mb-0">Secure Payments</h6>
                <span className="text-sm text-heading">
                  Safe and encrypted payment processing for every transaction.
                </span>
              </div>
            </div>
          </div>
          <div
            className="col-xxl-3 col-sm-6 aos-init aos-animate"
            data-aos="zoom-in"
            data-aos-duration="1000"
          >
            <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
              <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                <i className="ph-fill ph-chats" />
              </span>
              <div className="">
                <h6 className="mb-0">24/7 Support</h6>
                <span className="text-sm text-heading">
                  Dedicated customer support available anytime you need help.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Claims;
